// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QHUY","content":"styles_content__2JD3U","tableWrap":"styles_tableWrap__3066h"};